import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en/translation.json';
import hi from './hi/translation.json';
import de from './de/translation.json';
import es from './es/translation.json';
import tr from './tr/translation.json';
import useLocalizationStore from 'store/localization';

interface Translations {
	PlaceHolder: {
		[key: string]: string;
	};
	Validation: {
		[key: string]: string | { [key: string]: string };
	};
}

interface Languages {
	[key: string]: {
		translation: Translations;
	};
}

const LANGUAGES: Languages = {
	en: {
		translation: en,
	},
	hi: {
		translation: hi,
	},
	tr: {
		translation: tr,
	},
	de: {
		translation: de,
	},
	es: {
		translation: es,
	},
};

// Set language from Zustand store or fallback to localStorage
const { activeLanguage } = useLocalizationStore.getState();

i18n.use(initReactI18next).init({
	lng: localStorage.getItem('i18nextLng') ?? activeLanguage ?? 'en',
	fallbackLng: 'en',
	debug: true,
	interpolation: {
		escapeValue: false,
	},
	resources: LANGUAGES,
});

i18n.on('languageChanged', (lng) => {
	localStorage.setItem('i18nextLng', lng);
	// No need to reload, components will re-render based on language change
});

export default i18n;
